import React from 'react';
import { Box, Grid } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const LinksGroupSectionSkeleton = () => (
  <Box px={2} py={3}>
    <Skeleton variant="text" width="290px" height={50} />
    <Grid container rowSpacing={2}>
      {[...Array(6).keys()].map((item) => (
        <Grid item xs={12} md={12} lg={4} key={item}>
          <Skeleton variant="text" width="200px" height={30} />
        </Grid>
      ))}
    </Grid>
  </Box>
);
export { LinksGroupSectionSkeleton };
